import { render } from "./SignUpForm.vue?vue&type=template&id=00e4bdce&scoped=true&ts=true"
import script from "./SignUpForm.vue?vue&type=script&lang=ts"
export * from "./SignUpForm.vue?vue&type=script&lang=ts"

import "./SignUpForm.vue?vue&type=style&index=0&id=00e4bdce&scoped=true&lang=scss"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e4bdce"]])

export default __exports__